import { mapGetters } from 'vuex'
import Section from '@/components/Section/Section'
import CalibrationRow from '@/components/CalibrationRow/CalibrationRow'
import Spinner from '@/components/Spinner/Spinner'
import Pagination from '@/components/Pagination/Pagination'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  name: 'Calibrations',
  components: {
    Section,
    Spinner,
    FontAwesomeIcon,
    CalibrationRow,
    Pagination
  },
  created() {
    this.getCalibrations()
  },
  computed: {
    ...mapGetters({
      isLoading: 'calibrationsLoading',
      error: 'calibrationsError',
      calibrations: 'calibrations',
      count: 'calibrationCount',
      page: 'calibrationPage'
    })
  },
  watch: {
    page(val) {
      this.$store.dispatch('getCalibrations', { vehicle: this.vehicleId, page: val })
    }
  },
  methods: {
    getCalibrations() {
      this.$store.dispatch('getCalibrations')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Calibrations/script.js